var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('h1',[_vm._v("webcg-studio")]),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.status)+"\n    "),(!_vm.hasError)?_c('icon',{staticClass:"fa-spin",attrs:{"name":"spinner"}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0737af1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/welcome.vue
// module id = 1501
// module chunks = 1